import { Button, Message, useToaster } from 'rsuite';
import React from 'react';

import * as coursesApi from '../../../api/courses';
import { FormModal } from '../../../common/FormModal';
import { useFormErrors } from '../../../common/useFormErrors';
import CourseModalContent from './CourseModalContent';

type Props = {
  open: boolean;
  setOpen: (newValue: boolean) => void;
  callback: () => void;
};

export default function CreateCourseModal({ open, setOpen, callback }: Props) {
  const toaster = useToaster();
  const { errorSummary, setApiError, clearErrors } = useFormErrors({
    fallbackMessage: 'Не вдалося створити курс. Спробуйте пізніше',
    resetOn: [open],
  });
  const [modalCourseName, setModalCourseName] = React.useState<string>('');
  const [modalCourseCipher, setModalCourseCipher] = React.useState<string>('');
  const [modalCourseNameEn, setModalCourseNameEn] = React.useState<string>('');
  const [modalCourseNameDe, setModalCourseNameDe] = React.useState<string>('');
  const [modalCourseDescription, setModalCourseDescription] =
    React.useState<string>('');
  const [modalCourseDescriptionEn, setModalCourseDescriptionEn] =
    React.useState<string>('');
  const [modalCourseDescriptionDe, setModalCourseDescriptionDe] =
    React.useState<string>('');
  const [modalCourseShortDescription, setModalCourseShortDescription] =
    React.useState<string>('');
  const [modalCourseShortDescriptionEn, setModalCourseShortDescriptionEn] =
    React.useState<string>('');
  const [modalCourseShortDescriptionDe, setModalCourseShortDescriptionDe] =
    React.useState<string>('');
  const [modalCourseActive, setModalCourseActive] =
    React.useState<boolean>(false);
  const [modalCourseAcceptsRequests, setModalCourseAcceptsRequests] =
    React.useState<boolean>(false);
  const [modalCoursePriority, setModalCoursePriority] =
    React.useState<number>(0);

  return (
    <FormModal
      open={open}
      onClose={() => setOpen(false)}
      title="Створити курс"
      errorSummary={errorSummary}
      footer={
        <>
          <Button
            onClick={async () => {
              clearErrors();
              try {
                await coursesApi.create(
                  modalCourseCipher,
                  modalCourseName,
                  modalCourseNameEn,
                  modalCourseNameDe,
                  modalCourseDescription,
                  modalCourseDescriptionEn,
                  modalCourseDescriptionDe,
                  modalCourseActive,
                  modalCourseAcceptsRequests,
                  modalCourseShortDescription,
                  modalCourseShortDescriptionEn,
                  modalCourseShortDescriptionDe,
                  modalCoursePriority
                );
                toaster.push(
                  <Message type="success" showIcon closable>
                    Курс створено
                  </Message>,
                  {
                    placement: 'topEnd',
                    duration: 1500,
                  }
                );
                setOpen(false);
                setModalCourseName('');
                setModalCourseCipher('');
                setModalCourseNameEn('');
                setModalCourseNameDe('');
                setModalCourseDescription('');
                setModalCourseDescriptionEn('');
                setModalCourseDescriptionDe('');
                setModalCourseShortDescription('');
                setModalCourseShortDescriptionEn('');
                setModalCourseShortDescriptionDe('');
                setModalCourseActive(false);
                setModalCourseAcceptsRequests(false);
                setModalCoursePriority(0);
                callback();
              } catch (err: any) {
                console.error(err);
                const errorMessage = setApiError(err)[0];
                toaster.push(
                  <Message type="error" showIcon closable>
                    {errorMessage}
                  </Message>,
                  {
                    placement: 'topEnd',
                    duration: 1500,
                  }
                );
              }
            }}
            appearance="primary"
          >
            Створити
          </Button>
          <Button onClick={() => setOpen(false)} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <CourseModalContent
        modalCourseCipher={modalCourseCipher}
        modalCourseName={modalCourseName}
        modalCourseNameEn={modalCourseNameEn}
        modalCourseNameDe={modalCourseNameDe}
        modalCourseDescription={modalCourseDescription}
        modalCourseDescriptionEn={modalCourseDescriptionEn}
        modalCourseDescriptionDe={modalCourseDescriptionDe}
        modalCourseShortDescription={modalCourseShortDescription}
        modalCourseShortDescriptionEn={modalCourseShortDescriptionEn}
        modalCourseShortDescriptionDe={modalCourseShortDescriptionDe}
        modalCourseActive={modalCourseActive}
        modalCourseAcceptsRequests={modalCourseAcceptsRequests}
        modalCoursePriority={modalCoursePriority}
        setModalCourseCipher={setModalCourseCipher}
        setModalCourseName={setModalCourseName}
        setModalCourseNameEn={setModalCourseNameEn}
        setModalCourseNameDe={setModalCourseNameDe}
        setModalCourseDescription={setModalCourseDescription}
        setModalCourseDescriptionEn={setModalCourseDescriptionEn}
        setModalCourseDescriptionDe={setModalCourseDescriptionDe}
        setModalCourseShortDescription={setModalCourseShortDescription}
        setModalCourseShortDescriptionEn={setModalCourseShortDescriptionEn}
        setModalCourseShortDescriptionDe={setModalCourseShortDescriptionDe}
        setModalCourseActive={setModalCourseActive}
        setModalCourseAcceptsRequests={setModalCourseAcceptsRequests}
        setModalCoursePriority={setModalCoursePriority}
      />
    </FormModal>
  );
}
